function init() {
  var inputimgs = document.querySelectorAll(".input_img");
  if (!inputimgs) return;
  inputimgs.forEach(function (inputimg) {
    let id = inputimg?.id?.split("*")[1];
    inputimg.addEventListener("click", function () {
      let idName = id + "__main--customerpassword";
      var form_control_input = document.querySelector("#" + id);
      if (form_control_input) {
        if (form_control_input.type == "password") {
          // document.querySelector(".input_img_hidden").hidden = true;
          // document.querySelector(".input_img_view").hidden = false;
          document.querySelector("#" + id).type = "text";
            inputimg.src = "//ringconn.jp/cdn/shop/t/54/assets/view.svg?v=93999776838137558691768218457"
        } else {
          // document.querySelector(".input_img_hidden").hidden = false;
          // document.querySelector(".input_img_view").hidden = true;
          document.querySelector("#" + id).type = "password";
          inputimg.src = "//ringconn.jp/cdn/shop/t/54/assets/hidden.svg?v=79978484582135763311768218416"
        }
      }
    });
  });
}
setTimeout(init(), 1000);
